/* LM plus (preview 21 okt 2026): 1) winkelwagen: 1 bijpassend item met maat + toevoegen, 2) winkelwagen: kleur en maat wijzigen per regel. PDP-deel staat in lm-plus-pdp.js. */
(function () {
if (window.__lmPlus) return;
window.__lmPlus = true;
var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var cache = {};
function getJSON(u) {
if (!cache[u]) cache[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
return cache[u];
}
function fresh(u) { return fetch(u, { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }
function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
function optNames(p) { return (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }); }
function isSize(n) { return /^(size|maat)$/i.test(n || ''); }
function baseTitle(t) { var i = (t || '').lastIndexOf(' | '); return i > 0 ? t.slice(0, i) : null; }
function colorOf(t) { var i = (t || '').lastIndexOf(' | '); return i > 0 ? t.slice(i + 3) : ''; }
function img(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
function post(path, body) {
return fetch(root + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
.then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
}
function siblings(title) {
var b = baseTitle(title);
if (!b) return Promise.resolve([]);
return getJSON(root + 'search/suggest.json?q=' + encodeURIComponent(b) + '&resources[type]=product&resources[limit]=10')
.then(function (d) {
var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
return ps.filter(function (p) { return p.title.indexOf(b + ' | ') === 0; });
}).catch(function () { return []; });
}
/* ---------- stijl (assets/lm-plus.css) ---------- */
var me = document.currentScript;
var cssUrl = me && me.getAttribute('data-css');
if (cssUrl && !document.getElementById('lm-plus-css')) {
var lk = document.createElement('link'); lk.id = 'lm-plus-css'; lk.rel = 'stylesheet'; lk.href = cssUrl; document.head.appendChild(lk);
}
/* ---------- winkelwagen verversen ---------- */
function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
function refreshCart() {
if (onCartPage()) { location.reload(); return Promise.resolve(); }
return Promise.all([
fresh(root + 'cart.js'),
fetch(root + '?sections=cart-drawer,cart-counter', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); })
]).then(function (r) {
var cart = r[0]; cart.sections = r[1];
var d = document.querySelector('cart-drawer');
if (d && typeof d.renderContents === 'function') { d.renderContents(cart, false); }
else {
var t = document.querySelector('#CartDrawer-Body');
var n = new DOMParser().parseFromString(r[1]['cart-drawer'] || '', 'text/html').querySelector('#CartDrawer-Body');
if (t && n) t.innerHTML = n.innerHTML;
}
if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
if (typeof window.updateFreeShipping === 'function') window.updateFreeShipping();
});
}
function swap(box, newId) {
var key = box.getAttribute('data-key');
var q = parseInt(box.getAttribute('data-qty'), 10) || 1;
box.classList.add('is-busy');
/* eerst nieuwe variant toevoegen (faalt netjes als hij op is), dan oude regel weg */
return post('cart/add.js', { items: [{ id: newId, quantity: q }] })
.then(function () { return post('cart/change.js', { id: key, quantity: 0 }); })
.then(refreshCart)
.catch(function () {
box.classList.remove('is-busy');
var pnl = box.querySelector('.lm-li__panel');
if (pnl) { pnl.hidden = false; pnl.insertAdjacentHTML('beforeend', '<div class="lm-li__msg">Dit lukte niet. Probeer een andere maat.</div>'); }
});
}
/* ---------- 2. kleur en maat wijzigen per regel ---------- */
var linesBusy = false;
function enhanceLines() {
var lines = document.querySelectorAll('.cart-item[id^="CartItem-"]');
if (!lines.length || linesBusy) return;
var todo = [].filter.call(lines, function (el) { return !el.hasAttribute('data-lm-li'); });
if (!todo.length) return;
todo.forEach(function (el) { el.setAttribute('data-lm-li', '1'); });
linesBusy = true;
fresh(root + 'cart.js').then(function (cart) {
todo.forEach(function (el) {
if (el.querySelector('.lm-li')) return;
var idx = parseInt(el.id.replace('CartItem-', ''), 10) - 1;
var it = cart.items[idx];
if (!it || it.final_price === 0 || it.product_has_only_default_variant) return;
var box = document.createElement('div');
box.className = 'lm-li';
box.setAttribute('data-key', it.key);
box.setAttribute('data-qty', it.quantity);
box.setAttribute('data-variant', it.variant_id);
box.setAttribute('data-handle', it.handle);
box.setAttribute('data-title', it.product_title);
box.innerHTML = '<button type="button" class="lm-li__btn" data-lm-color hidden>Kleur wijzigen</button>' +
'<button type="button" class="lm-li__btn" data-lm-size hidden>Maat wijzigen</button>' +
'<div class="lm-li__panel" hidden></div>';
var host = el.querySelector('.cart-item__content') || el.querySelector('.cart-item__details') || el;
var err = host.querySelector('[data-line-item-error]');
if (err) host.insertBefore(box, err); else host.appendChild(box);
getJSON(root + 'products/' + it.handle + '.js').then(function (p) {
var si = optNames(p).findIndex(isSize);
if (si > -1 && p.variants.length > 1) box.querySelector('[data-lm-size]').hidden = false;
}).catch(function () {});
siblings(it.product_title).then(function (s) {
if (s.filter(function (x) { return x.available && x.handle !== it.handle; }).length) box.querySelector('[data-lm-color]').hidden = false;
});
});
}).catch(function () {}).then(function () { linesBusy = false; });
}
function sizeButtons(p, currentVariantId) {
var names = optNames(p);
var si = names.findIndex(isSize);
var cur = p.variants.filter(function (v) { return v.id === currentVariantId; })[0];
var vs = p.variants.filter(function (v) {
if (si < 0) return true;
if (!cur) return true;
for (var i = 0; i < names.length; i++) { if (i !== si && v['option' + (i + 1)] !== cur['option' + (i + 1)]) return false; }
return true;
});
return vs.map(function (v) {
var label = si > -1 ? v['option' + (si + 1)] : v.title;
var isCur = v.id === currentVariantId;
return '<button type="button" class="lm-li__opt' + (isCur ? ' is-current' : '') + '" data-lm-pick="' + v.id + '"' + (isCur ? ' aria-current="true" title="Huidige maat"' : '') + (!v.available && !isCur ? ' disabled' : '') + '>' + esc(label) + '</button>';
}).join('');
}
document.addEventListener('click', function (e) {
var t = e.target;
if (!t.closest) return;
var b = t.closest('[data-lm-size]');
if (b) {
e.preventDefault();
var box = b.closest('.lm-li'), pnl = box.querySelector('.lm-li__panel');
if (!pnl.hidden && pnl.getAttribute('data-mode') === 'size') { pnl.hidden = true; return; }
getJSON(root + 'products/' + box.getAttribute('data-handle') + '.js').then(function (p) {
pnl.setAttribute('data-mode', 'size');
pnl.innerHTML = sizeButtons(p, parseInt(box.getAttribute('data-variant'), 10));
pnl.hidden = false;
});
return;
}
var c = t.closest('[data-lm-color]');
if (c) {
e.preventDefault();
var box2 = c.closest('.lm-li'), pnl2 = box2.querySelector('.lm-li__panel');
if (!pnl2.hidden && pnl2.getAttribute('data-mode') === 'color') { pnl2.hidden = true; return; }
var own = box2.getAttribute('data-handle');
Promise.all([siblings(box2.getAttribute('data-title')), getJSON(root + 'products/' + own + '.js').catch(function () { return null; })]).then(function (r) {
var list = r[0].filter(function (x) { return x.available && x.handle !== own; });
var me = r[1];
pnl2.setAttribute('data-mode', 'color');
if (!list.length) { pnl2.innerHTML = '<div class="lm-li__hint">Geen andere kleuren op voorraad.</div>'; pnl2.hidden = false; return; }
var curTile = me ? '<button type="button" class="lm-li__col is-current" data-lm-close aria-current="true" title="Huidige kleur"><img src="' + esc(img(me.featured_image || '', 120)) + '" alt="" loading="lazy">' + esc(colorOf(me.title)) + '</button>' : '';
pnl2.innerHTML = curTile + list.map(function (x) {
var im = x.image || (x.featured_image && x.featured_image.url) || '';
return '<button type="button" class="lm-li__col" data-lm-sib="' + esc(x.handle) + '"><img src="' + esc(img(im, 120)) + '" alt="" loading="lazy">' + esc(colorOf(x.title)) + '</button>';
}).join('');
pnl2.hidden = false;
});
return;
}
var cl = t.closest('[data-lm-close]');
if (cl && cl.closest('.lm-li')) { e.preventDefault(); cl.closest('.lm-li__panel').hidden = true; return; }
var sib = t.closest('[data-lm-sib]');
if (sib) {
e.preventDefault();
var box3 = sib.closest('.lm-li'), pnl3 = box3.querySelector('.lm-li__panel');
Promise.all([
getJSON(root + 'products/' + box3.getAttribute('data-handle') + '.js'),
getJSON(root + 'products/' + sib.getAttribute('data-lm-sib') + '.js')
]).then(function (r) {
var own = r[0], np = r[1];
var oi = optNames(own).findIndex(isSize), ni = optNames(np).findIndex(isSize);
var cur = own.variants.filter(function (v) { return v.id === parseInt(box3.getAttribute('data-variant'), 10); })[0];
var size = cur && oi > -1 ? cur['option' + (oi + 1)] : null;
var match = np.variants.filter(function (v) { return v.available && (ni < 0 || !size || v['option' + (ni + 1)] === size); })[0];
if (match && (size || np.variants.length === 1)) { swap(box3, match.id); return; }
/* zelfde maat niet beschikbaar: laat de maten van de nieuwe kleur zien */
pnl3.setAttribute('data-mode', 'size');
pnl3.innerHTML = '<div class="lm-li__hint">' + esc(colorOf(np.title)) + (size ? ' is niet meer in maat ' + esc(size) + '. Kies een maat:' : ': kies een maat') + '</div>' + sizeButtons(np, -1);
});
return;
}
var pick = t.closest('[data-lm-pick]');
if (pick && pick.closest('.lm-li')) {
e.preventDefault();
if (pick.classList.contains('is-current')) { pick.closest('.lm-li__panel').hidden = true; return; }
swap(pick.closest('.lm-li'), parseInt(pick.getAttribute('data-lm-pick'), 10));
}
});
/* ---------- 1. een bijpassend item in de winkelwagen ---------- */
var upBusy = false;
var FALLBACK = ['bag-alanna-black', 'bag-alanna-beige'];
function pickUpsell(cart) {
var items = cart.items.filter(function (i) { return i.final_price > 0; });
var inCart = {};
cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
var pids = [];
items.forEach(function (i) { if (pids.indexOf(i.product_id) < 0) pids.push(i.product_id); });
function ok(p) { return p && p.available && !inCart[p.id] && p.price > 0 && !/^set\b/i.test(p.title) && !/giftcard|cadeau/i.test(p.title); }
var chain = Promise.resolve(null);
pids.forEach(function (pid) {
chain = chain.then(function (found) {
if (found) return found;
return getJSON(root + 'recommendations/products.json?product_id=' + pid + '&intent=complementary&limit=6')
.then(function (d) { return (d.products || []).filter(ok)[0] || null; })
.catch(function () { return null; });
});
});
FALLBACK.forEach(function (h) {
chain = chain.then(function (found) {
if (found) return found;
return getJSON(root + 'products/' + h + '.js').then(function (p) { return ok(p) ? p : null; }).catch(function () { return null; });
});
});
return chain;
}
function renderUpsell(p) {
var names = optNames(p), si = names.findIndex(isSize);
var avail = p.variants.filter(function (v) { return v.available; });
var single = p.variants.length === 1 || si < 0;
var im = p.featured_image || (p.images && p.images[0]) || '';
if (im && typeof im === 'object') im = im.src || im.url || '';
var name = baseTitle(p.title) || p.title, col = colorOf(p.title);
var sizes = single ? '' : '<div class="lm-up__sizes">' + p.variants.map(function (v) {
return '<button type="button" class="lm-up__s" data-lm-up-v="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v['option' + (si + 1)]) + '</button>';
}).join('') + '</div>';
var firstId = single && avail[0] ? avail[0].id : '';
return '<div class="lm-up" data-lm-up data-sel="' + firstId + '">' +
'<div class="lm-up__k">Maak je look af</div>' +
'<div class="lm-up__row">' +
'<a href="' + esc(p.url || ('/products/' + p.handle)) + '"><img class="lm-up__img" src="' + esc(img(im, 160)) + '" alt="" loading="lazy"></a>' +
'<div><a class="lm-up__t" href="' + esc(p.url || ('/products/' + p.handle)) + '">' + esc(name) + (col ? '<span class="lm-up__c">' + esc(col) + '</span>' : '') + '</a>' +
'<div class="lm-up__p">' + money(p.price) + '</div>' + sizes +
'<button type="button" class="lm-up__add" data-lm-up-add' + (firstId ? '' : ' disabled') + '>' + (firstId ? 'Toevoegen +' : 'Kies je maat') + '</button>' +
'</div></div></div>';
}
function upsell() {
var host = document.querySelector('#CartDrawer-Body #CartDrawer-CartItems');
if (!host || upBusy) return;
if (host.hasAttribute('data-lm-up-done')) return;
host.setAttribute('data-lm-up-done', '1');
upBusy = true;
fresh(root + 'cart.js').then(function (cart) {
if (!cart.items.length) return null;
return pickUpsell(cart);
}).then(function (p) {
var h = document.querySelector('#CartDrawer-Body #CartDrawer-CartItems');
if (!p || !h || h.querySelector('[data-lm-up]')) return;
h.insertAdjacentHTML('beforeend', renderUpsell(p));
}).catch(function () {}).then(function () { upBusy = false; });
}
document.addEventListener('click', function (e) {
var t = e.target;
if (!t.closest) return;
var s = t.closest('[data-lm-up-v]');
if (s) {
e.preventDefault();
var up = s.closest('[data-lm-up]');
[].forEach.call(up.querySelectorAll('.lm-up__s'), function (b) { b.classList.remove('is-on'); });
s.classList.add('is-on');
up.setAttribute('data-sel', s.getAttribute('data-lm-up-v'));
var a = up.querySelector('[data-lm-up-add]');
a.disabled = false; a.textContent = 'Toevoegen +';
return;
}
var add = t.closest('[data-lm-up-add]');
if (add) {
e.preventDefault();
var up2 = add.closest('[data-lm-up]'), id = parseInt(up2.getAttribute('data-sel'), 10);
if (!id) return;
up2.classList.add('is-busy');
try { (window.Shopify && Shopify.analytics && Shopify.analytics.publish) && Shopify.analytics.publish('lm_cart_upsell_add', { variant_id: id }); } catch (er) {}
if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'lm_cart_upsell_add', variant_id: id });
post('cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(refreshCart).catch(function () { up2.classList.remove('is-busy'); add.textContent = 'Niet gelukt, probeer opnieuw'; });
}
});
/* ---------- starten en bij elke herbouw opnieuw ---------- */
var tmr = null;
function run() { tmr = null; enhanceLines(); upsell(); }
function soon() { if (!tmr) tmr = setTimeout(run, 200); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
})();